/* istanbul ignore file */
export { default } from './Checkbox';
